module.exports = __webpack_public_path__ + "static/flags/SK-5d0f97014ef998dac9be8d143437ad5c.gif";